import ListBonDocuments from "./ListBonDocuments";

const ListBonReception = () => (
  <ListBonDocuments
    transactionType={0}
    title="Bons de réception"
    icon="fa-clipboard-check"
    subtitle="Consultez les bons de réception d'un dépôt sur une période"
    singular="bon de réception"
    plural="bons de réception"
  />
);
export default ListBonReception;
